import dayjs from 'dayjs';

export const weekData = {
  0: 'Sun',
  1: 'Mon',
  2: 'Tue',
  3: 'Wed',
  4: 'Thu',
  5: 'Fri',
  6: 'Sat',
};

export const formateDate = (date, format) => dayjs(date).format(format);

export const addTimeAndFormat = (date, format, hour, mins, second) => dayjs(date).set('hour', hour).set('minute', mins).set('second', second).format(format);

export const formateDateIntoISO = (date) => dayjs(date).toISOString();

export const subtractDate = (date, count, type) => dayjs(date).subtract(count, type);

export const getDiff = (type, end, start) => {
  let output = dayjs(end).diff(dayjs(start), type, true);

  output = Math.ceil(Math.abs(output));
  return output;
};